import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { EncryptStorage } from "encrypt-storage";
import { useFormik } from "formik";
import React, { useState } from 'react';
import * as yup from "yup";

const validationSchema = yup.object({  
});


function DuplicateCustomTimeline({duplicateTimeline, timelineobj}) {
    const [open, setOpen]                       = useState(false); 
    const encryptStorage                        = new EncryptStorage("secret-key");
    const decypt_data                           = encryptStorage.getItem("case_details");  
    const [source, setSource]                   = useState('procedural');
    const [isValid, setIsValid]                 = useState(false);
    const [title, setTitle]                     = useState('');
    const [notes, setNotes]                     = useState('');

    const onSubmit = async (values,props) =>{  
        values["client_case_id"]    = decypt_data.case.id; 
        values['create_method']     = 'duplicate';
        values['id']                = timelineobj.id;

        duplicateTimeline(values);  
        handleClose(); 
    }

    function handleClickOpen() {
        setSource('procedural');
        setTitle('');
        setOpen(true); 
        formik.resetForm();
    }

    function handleClose() {
        setOpen(false);
    }

    const formik = useFormik( 
    {
        initialValues: {
            notes: "", 
        },
        validateOnBlur:true,
        onSubmit,
        validationSchema: validationSchema
    });

    const editEvent =()=> {
        const values = {
            client_case_id: decypt_data.case.id,
            create_method: 'duplicate',
            title: title,
            notes: notes, 
            id: timelineobj.id
        };
 
        duplicateTimeline(values);
    }

    const onChange =(e)=>{ 
        if(e.target.value.length > 2) { 
            setTitle(e.target.value) 
            setIsValid(true);
        } else {
            setIsValid(false);
        } 
    }
    return (
        <> 
            <Button className="w-100 d-flex justify-content-between p-3" onClick={handleClickOpen}>
                Duplicate Timeline
                <FileCopyIcon/>
            </Button> 
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Duplicate Timeline</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                <form onSubmit={formik.handleSubmit}>
                      <div className="form-group row">  
                        <div className="col-lg-12 mb-4">
                        <label>Title</label>
                            <TextField
                                placeholder="Title"
                                label="Title"
                                name="title"
                                onChange={onChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.title}
                                variant="outlined"
                                className="custom-border"
                            />
                            <br/>
                            <span className='text-danger'>
                                {formik.touched.title &&  formik.errors.title ? formik.errors.title:""}
                            </span>
                        </div>
                        <div className="col-lg-12 mb-4">
                            <label>Notes</label>
                            <TextField 
                                label="Notes"
                                name="notes"
                                multiline
                                onChange={(e)=> setNotes(e.target.value)}
                                onBlur={formik.handleBlur} 
                                className="custom-border"
                                // variant="outlined"
                                rows={4}
                            /> 
                            <br/>
                            <span className='text-danger'>
                                {formik.touched.notes &&  formik.errors.notes ? formik.errors.notes:""}
                            </span>
                        </div> 
                      </div>   
                    <DialogActions>
                        <Button onClick={handleClose} variant="contained" size="large" color="secondary">
                            Cancel
                        </Button>
                        <Button 
                            className="text-white" 
                            variant="contained" 
                            color="primary" 
                            size="large" 
                            type="submit" 
                            disabled={!isValid} 
                            autoFocus
                            onClick={editEvent}
                        >
                            Submit
                        </Button>
                      </DialogActions>
                    </form>
                </DialogContentText>
                </DialogContent> 
            </Dialog> 
        </>
    )
}

export default DuplicateCustomTimeline
